const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/networkActions.ts';
import { KISAPI as API } from '../middleware/kisapi';
import { kisapiActionTypes } from '../defs/actionTypes';
import { apiPingKisApi } from '@cistec/common_web/actions/kisapi/utils';

export const atCacheRequest = 'CACHE_HTTP_REQUEST';
export const atClearCache = 'CLEAR_CACHE';
export const atSetCurrentBaseUrl = 'NET_SET_CURRENT_BASEURL';
export const atCheckConnectivity = kisapiActionTypes('NET_CHECK_CONNECTION');

export function actionCacheRequest(key: string, response: any) {
    return {
        type: atCacheRequest,
        payload: {
            key,
            data: response,
        },
    };
}

export function actionClearCache(key: string) {
    return {
        type: atClearCache,
        payload: {
            key,
        },
    };
}

/**
 * Checks for connectivity by calling ping service. The result will be used to show or dismiss the offline status of the device.
 * @param forceFail forces ping to fail (valuable debug parameter).
 */
export function actionCheckConnectivity(forceFail?: boolean) {
    return {
        type: atCheckConnectivity.combined,
        [API]: apiPingKisApi(forceFail),
        meta: { suppressErrorMsg: true, forceFail },
    };
}

export type CheckConnectivityAction = ReturnType<typeof actionCheckConnectivity>;

export function actionSetCurrentBaseUrl(baseUrl: string | null) {
    return {
        type: atSetCurrentBaseUrl,
        payload: {
            baseUrl,
        },
    };
}
